import RegisterForm from "../../../layouts/auth/RegisterForm";

export default function RegisterPage() {
  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded shadow mt-10">
      <h2 className="text-xl font-semibold mb-4 text-center">Đăng ký tài khoản</h2>
      <RegisterForm />
    </div>
  );
}
